import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-help",
  templateUrl: "./med-icon-help.component.html",
})
export class MedIconHelpComponent extends SvgMixinComponent {}
